import { isEmpty } from 'lodash';
import { __experimentalDivider as Divider } from '@wordpress/components';
import { __experimentalLinkControl as LinkControl } from '@wordpress/block-editor';

const {
  i18n: { __ },
  components: { Button, SelectControl, ToggleControl },
  blockEditor: { MediaUpload, MediaUploadCheck },
} = wp;

const VideoPopup = ({ attributes, setAttributes }) => {
  const {
    videoSource,
    video,
    useFallbackVideo,
    fallbackVideo,
    videoLink,
    // aspectRatios,
  } = attributes;
  return (
    <>
      <SelectControl
        label={__('Video Type', 'b3rg')}
        value={videoSource}
        options={[
          { label: 'Select/Upload Video', value: 'upload' },
          { label: 'Video URL', value: 'url' },
        ]}
        onChange={(videoSource) => {
          setAttributes({ videoSource });
        }}
      />
      <Divider />
      {videoSource === 'upload' && (
        <>
          <MediaUploadCheck>
            <MediaUpload
              onSelect={(file) => {
                setAttributes({
                  video: {
                    id: file.id,
                    title: file.title,
                    filename: file.filename,
                    url: file.url,
                    fileType: file.type,
                  },
                });
              }}
              allowedTypes={['video']}
              multiple={false}
              render={({ open }) => (
                <>
                  {video && (
                    <div className="e-cmp__media-preview">
                      <p>{video.filename}</p>
                    </div>
                  )}
                  <div className="e-cmp__media-buttons">
                    <Button onClick={open} variant="primary">
                      {isEmpty(video)
                        ? __('Select a Video', 'b3rg')
                        : __('Replace', 'b3rg')}
                    </Button>
                    {!isEmpty(video) && (
                      <Button
                        variant="secondary"
                        onClick={() =>
                          setAttributes({
                            video: {},
                          })
                        }
                      >
                        {__('Remove', 'b3rg')}
                      </Button>
                    )}
                  </div>
                </>
              )}
            />
          </MediaUploadCheck>
          <Divider />
          <ToggleControl
            label={__('Enable Fallback Video', 'b3rg')}
            help={__(
              "Add a fallback video to be displayed in case if the browser doesn't support the regular video (Video extension should be different from regular video)",
              'b3rg',
            )}
            checked={useFallbackVideo}
            onChange={(useFallbackVideo) => {
              setAttributes({ useFallbackVideo });
            }}
          />
          {useFallbackVideo && (
            <>
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={(file) => {
                    setAttributes({
                      fallbackVideo: {
                        id: file.id,
                        title: file.title,
                        filename: file.filename,
                        url: file.url,
                        fileType: file.type,
                      },
                    });
                  }}
                  allowedTypes={['video']}
                  multiple={false}
                  render={({ open }) => (
                    <>
                      {fallbackVideo && (
                        <div className="e-cmp__media-preview">
                          <p>{fallbackVideo.filename}</p>
                        </div>
                      )}
                      <div className="e-cmp__media-buttons">
                        <Button onClick={open} variant="primary">
                          {isEmpty(fallbackVideo)
                            ? __('Select the Fallback Video', 'b3rg')
                            : __('Replace', 'b3rg')}
                        </Button>
                        {!isEmpty(fallbackVideo) && (
                          <Button
                            variant="secondary"
                            onClick={() =>
                              setAttributes({
                                fallbackVideo: {},
                              })
                            }
                          >
                            {__('Remove', 'b3rg')}
                          </Button>
                        )}
                      </div>
                    </>
                  )}
                />
              </MediaUploadCheck>
              <Divider />
              <ToggleControl
                label={__('Transparency', 'b3rg')}
                help={__(
                  'Enable this if the fallback video is transparent',
                  'b3rg',
                )}
                checked={fallbackVideo.transparency}
                onChange={(transparency) => {
                  setAttributes({
                    fallbackVideo: {
                      ...fallbackVideo,
                      transparency,
                    },
                  });
                }}
              />
            </>
          )}
        </>
      )}
      {videoSource === 'url' && (
        <>
          <LinkControl
            searchInputPlaceholder={__('Enter the video link here…', 'b3rg')}
            value={videoLink}
            onChange={(selection) => {
              setAttributes({
                videoLink: {
                  ...selection,
                  title: selection.url,
                },
              });
            }}
            settings={[]}
            onRemove={() => setAttributes({ videoLink: {} })}
            /* TODO: Need to exclude attachments from search results */ // NOSONAR
            withCreateSuggestion={false}
          ></LinkControl>
          <div className="placeholder-text">
            {__('Supports links to YouTube, Vimeo and Wistia', 'b3rg')}
          </div>
          {/* This needs to be enabled only if needed */}
          {/* <SelectControl
            label={__('Aspect Ratios', '')}
            options={[
              { value: 'embed-responsive-21by9', label: '21:9' },
              { value: 'embed-responsive-16by9', label: '16:9' },
              { value: 'embed-responsive-4by3', label: '4:3' },
              { value: 'embed-responsive-1by1', label: '1:1' },
            ]}
            value={aspectRatios}
            onChange={(aspectRatios) => setAttributes({ aspectRatios })}
          /> */}
        </>
      )}
    </>
  );
};

export default VideoPopup;
